/**
 * Custom Grilla JS File
 * Should be compiled with Codekit
 * @author  Twilo Creative
 */
// Grilla Global Config
import jQuery from "./modules/jquery/jquery-3.6.1.min.js"
export const grillaConfig = {
	accordion: {
		// This should usually match the value of $transitionSpeed in brand.scss
		animationDuration: 250
	},
	animation: {
		windowProportion: (9/10),
	},
	fixedHeaderConfig: {
		minScroll: 130,
		upPadding: 130
	}
};
jQuery(document).ready(function($) {
	console.info('Grilla: Developed and maintained by Trade Town Ltd');
	$('body').addClass('ready');

	// Contact Form 7
	// Fade out errors after interaction
	$('.wpcf7-form-control').on('click', function() {
		$(this).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').fadeOut();
	});
	$('.wpcf7-form-control').on('input', function() {
		$(this).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').fadeOut();
	});
	$('.wpcf7-form-control').on('change', function() {
		$(this).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').fadeOut();
	});

	// Adds a redirect to a thank you page from contact form 7
	// Uncomment to use - requires a Thank You page to be setup
	// document.addEventListener( 'wpcf7mailsent', function( event ) {
	//     window.location.href = "/thank-you/";
	// }, false );

});